import Mutations from '../../odata/mutations';

export default { ...new Mutations('questionAlternative'), ...new Mutations('questionAlternatives') };
